export default function Up(status) {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity={status.status ? "0.2" : "0.6"} clipPath="url(#clip0_3_17584)">
        <path d="M25 39.5833V10.4166" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M12.5 22.9167L25 10.4167"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.5 22.9167L25 10.4167"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_17584">
          <rect width="50" height="50" fill="white" transform="matrix(-1 0 0 -1 50 50)" />
        </clipPath>
      </defs>
    </svg>
  )
}
